import styled, { css } from 'styled-components';

export const AppContainer = styled.div`
  width: 100%;
  height: 100%;
  display: flex;
  flex-direction: column;
  align-items: center;
  justify-content: center;
  background: #555;
`;

export const Phone = styled.div`
	position: relative;
  width: ${props => props.width}px;
  height: ${props => props.height}px;
  background: blue;
  border: 2px solid #efefef;
  background: white;
  background: url(background.png);
  background-size: cover;
  background-position: center;
`;

export const PageContainer = styled.div`
	padding: 40px;
  text-align: center;
  padding-top: 80px;
`

export const Header = styled.div`
  position: absolute;
  top: 0;
  left: 0;
  width: 100%;
  height: 60px;
  padding: 15px;
  background: #efefef;
  border-bottom: 2px solid rgb(126, 69, 62);
  box-shadow: 0px 1px 3px rgba(0,0,0,0.2);
`

export const PageTitle = styled.div`
	font-size: 22px;
	text-align: center;
`

export const TextBox = styled.div`
  color: black;
  padding: 20px;
  margin-top: 40px;
  text-align: left;
  border: 2px solid rgb(126, 69, 62);
  border-radius: 5px;
  background: rgba(126, 70, 62, 0.2);
  box-shadow: 0px 1px 3px rgba(0,0,0,0.2);
`

export const TextBlock = styled.div`
	font-size: 20px;

	> span {
		font-size: 15px;
	}
`

export const Responses = styled.div`
  display: flex;
  flex-direction: row;
  align-items: center;
  justify-content: center;
  flex-wrap: wrap;
  width: 100%;
`;

export const ResponseContainer = styled.div`
  width: 150px;
  height: 140px;
  margin: 5px;
  background-image: url(${props => props.img});
  background-color: black;
  background-repeat: no-repeat;
  background-size: cover;
  display: flex;
  flex-direction: column;
  align-items: center;
  justify-content: center;
  position: relative;
  border: 2px solid gray;
  border-radius: 2px;
`;

export const ResponsePlayback = styled.div`
  width: 50px;
  height: 50px;
  filter: invert(1);
  background-image: url(${props => props.img});
  background-repeat: no-repeat;
  background-size: cover;
  opacity: 0.6;
  cursor: pointer;
`;

export const ResponsePrivacy = styled.div`
  position: absolute;
  top: 5px;
  right: 5px;
  filter: invert(1);
  width: 18px;
  height: 18px;
  background-image: url(${props => props.img});
  background-repeat: no-repeat;
  background-size: cover;
  opacity: 0.8;
  cursor: pointer;
`

export const BottomButtons = styled.div`
	display: flex;
	position: absolute;
  bottom: 40px;
  left: 10%;
  width: 80%;
`

export const Button = styled.button`
  display: flex;
	width: 100%;
  border: none;
  color: white;
  font-size: 16px;
  padding: 15px;
  background: rgb(126, 69, 62);
  border-radius: 5px;
  cursor: pointer;
  margin: auto;
  align-items: center;
  justify-content: center;

  &:active, &:focus {
  	outline: none;
  }

  ${props => props.disabled && css`
  	opacity: 0.3;
  	cursor: default;
  	pointer-events: none;
  `}
`


export const TopicList = styled.div`
  display: flex;
  flex-wrap: wrap;
`

export const Topic = styled.div`
  display: flex;
  width: 165px;
  height: 165px;
  padding: 10px;
  cursor: pointer;
  
  > div {
    position: relative;
    width: 100%;
    border: 2px solid #efefef;
    background-image: url(${props => props.img});
    background-size: cover;
    background-repeat: no-repeat;
    display: flex;
    justify-content: center;
    flex-direction: column;
    text-align: center;
    ${props => props.reduce && css`
      background-size: 50%;
      background-position: 50% 35%;
      background-color: rgba(0,0,0,0.5);
    `}
  }

  > div > span {
    text-align: center;
    width: 100%;
    font-size: 13px;
    font-weight: 600;
    text-transform: uppercase;
    margin-top: 10px;
    color: white;
    position: absolute;
    bottom: 0px;
    background: rgba(0,0,0,0.5);
    padding: 5px;
  }
    
  ${props => props.selected && css`
    background: #555;

    > div {
      border: 2px solid white;
    }    
  `}
`

